import log from 'salvo-lite/log'
import Choices from 'choices.js'

class Select {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._choices = null
        this._options = Object.assign({
            searchEnabled: false,
            removeItems: false,
            itemSelectText: '',
            shouldSort: false,
            classNames: {
                containerOuter: 'choices'
            }
        }, JSON.parse(elem.getAttribute('data-select')) || '{}')
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._choices = new Choices(this._elem, this._options)
        this._elem.addEventListener('destroy', e => {
            this._choices.destroy()
        })
        this._elem.addEventListener('reInit', e => {
            const reInitOptions = this._options
            reInitOptions.classNames.containerOuter = this._options.classNames.containerOuter.replace('disabled', '')
            this._choices = new Choices(this._elem, reInitOptions)
        })
    }
}

export default Select



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Select.js